import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function ExamplesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10 reveal">
          <SectionLabel label={dxAdvisoryData.examples.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {dxAdvisoryData.examples.title}
          </h2>
        </div>

        <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-2.5 md:gap-3">
          {dxAdvisoryData.examples.items.map((item, idx) => (
            <div
              key={idx}
              className="reveal flex items-start gap-2.5 p-3 md:p-3.5 rounded-lg bg-background-100 border border-background-200/50"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-chat-3-line text-primary-500 text-xs" />
              </div>
              <p className="text-sm text-foreground-800 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-6 md:mt-8 reveal">
          <p className="text-xs text-foreground-500">
            これ以外のご相談もお気軽にお問い合わせください
          </p>
        </div>
      </div>
    </section>
  );
}